export const defaultLineup =  {
	riders: [0, 0],
	constructors: [0],
	squads: [0],
	riders_reserve: [0, 0],
};
